<div class="card title p-1">
    Compliance
</div>
<!-- <div class="card"> -->
<mat-accordion displayMode="flat">
    <mat-expansion-panel class="holdsList">
        <mat-expansion-panel-header [class.selected-header]="selectedHeader === 1" (click)="selectedHeader = 1"
            collapsedHeight="38px" expandedHeight="38px">
            <mat-panel-title>Hold Info</mat-panel-title>
            <mat-divider></mat-divider>
        </mat-expansion-panel-header>
        <div *ngIf="!holdApplied && hold">
            <!-- <div style="display: flow-root;" class="mr-3 mb-3">
                    <button mat-stroked-button (click)="removeAllHolds()" style="float: right;cursor: pointer;"
                        title="Remove All Holds">
                        <mat-icon>remove_circle_outline</mat-icon>All Holds
                    </button>
                </div> -->
            <!-- <div *ngFor="let holdGroupName of holdGroupNames">
                    <mat-icon class="" style="float: right;cursor: pointer;" (click)="removeHold(holdGroupName)"
                        title="Remove Hold">
                        remove_circle_outline
                    </mat-icon>
                    <div style="text-align: center;" class="m-1">
                        <strong>{{holdGroupName}}</strong> has been applied on this document.
                    </div>
                </div> -->
            <table mat-table [dataSource]="holdsList" matSort aria-describedby="hold-list">

                <ng-container matColumnDef="holdName">
                    <th id="select" mat-header-cell *matHeaderCellDef>Hold</th>
                    <td mat-cell *matCellDef="let row">
                        {{row}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th id="select" mat-header-cell *matHeaderCellDef>Remove Hold</th>
                    <td mat-cell *matCellDef="let row">
                        <mat-icon class="" style="cursor: pointer;" (click)="removeHold(row)" title="Remove Hold">
                            remove_circle_outline
                        </mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="holdListCols"></tr>
                <tr mat-row *matRowDef="let row; columns: holdListCols;" class="element-row"
                    [class.selected-row]="selectedRow === row" (click)="selectedRow = selectedRow === row ? null : row">
                </tr>
            </table>

            <mat-paginator #myPaginator [pageSizeOptions]="[5,10, 20, 50]" [pageSize]="5" showFirstLastButtons>
            </mat-paginator>
        </div>
        <div *ngIf="!holdApplied">
            <mat-list-item>
                <form>
                    <div class="input-group-sm mb-3 mt-2 input-group col-12">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Hold</span>
                        </div>
                        <mat-select name="hold_names" class="form-control" [(ngModel)]="holdIDs" multiple>
                            <mat-option>
                                <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                    [noEntriesFoundLabel]="'Not found'" name="search" ngDefaultControl 
                                    [ngModelOptions]="{standalone: true}">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let hold of unappliedHolds|stringFilter:searchCtrl:'name'" [value]="hold.id">
                                {{hold.name}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <button class="mr-3 mb-3" style="float: right;" [disabled]="!holdIDs" mat-stroked-button
                        (click)="applyHold()">
                        Apply Hold
                    </button>
                </form>
            </mat-list-item>
        </div>
        <div *ngIf="holdApplied" style="text-align: center;">
            Hold has been applied.
            <button class="mr-3" style="float: right;" mat-stroked-button (click)="back()">
                Back
            </button>
        </div>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="archive">
        <mat-expansion-panel-header [class.selected-header]="selectedHeader === 1" (click)="selectedHeader = 1"
            collapsedHeight="38px" expandedHeight="38px">
            <mat-panel-title>Archival Info</mat-panel-title>
            <mat-divider></mat-divider>
        </mat-expansion-panel-header>
        <div>
            <mat-list-item>
                <div style="text-align: center;" *ngIf="isArchiveNull">
                    {{archiveMessage}}
                </div>
                <div *ngIf="!isArchiveNull">
                    <div *ngFor="let retention of retentionInfo">
                        <div class="border">
                            <div class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Retention</div>
                                    <div class="col-8 properties-value">{{retention.retentiongroupname}}</div>
                                </div>
                            </div>
                            <div class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Policy</div>
                                    <div class="col-8 properties-value">{{retention.archivalpolicyname}}</div>
                                </div>
                            </div>
                            <div class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Jurisdiction</div>
                                    <div class="col-8 properties-value">{{retention.archivalpolicyjurisdiction}}</div>
                                </div>
                            </div>
                            <div class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Policy Type</div>
                                    <div class="col-8 properties-value">{{retention.archivalpolicytype}}</div>
                                </div>
                            </div>
                            <div *ngIf="retention.policytype=='Duration'" class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Policy Duration</div>
                                    <div class="col-8 properties-value">{{retention.archivalpolicyduration}}</div>
                                </div>
                            </div>
                            <div class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Archival Date</div>
                                    <div class="col-8 properties-value">{{retention.archival_date | date}}</div>
                                </div>
                            </div>
                            <div class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Archival Status</div>
                                    <div class="col-8 properties-value">{{retention.archived}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-list-item>
        </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
        <mat-expansion-panel-header [class.selected-header]="selectedHeader === 1" (click)="selectedHeader = 1"
            collapsedHeight="38px" expandedHeight="38px">
            <mat-panel-title>Disposition Info</mat-panel-title>
            <mat-divider></mat-divider>
        </mat-expansion-panel-header>
        <div>
            <mat-list-item>
                <div style="text-align: center;" *ngIf="isNull">
                    {{message}}
                </div>
                <div *ngIf="!isNull">
                    <div *ngFor="let retention of retentionInfo">
                        <div class="border">
                            <div class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Retention</div>
                                    <div class="col-8 properties-value">{{retention.retentiongroupname}}</div>
                                </div>
                            </div>
                            <div class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Policy</div>
                                    <div class="col-8 properties-value">{{retention.policyname}}</div>
                                </div>
                            </div>
                            <div class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Jurisdiction</div>
                                    <div class="col-8 properties-value">{{retention.policyjurisdiction}}</div>
                                </div>
                            </div>
                            <div class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Policy Type</div>
                                    <div class="col-8 properties-value">{{retention.policytype}}</div>
                                </div>
                            </div>
                            <div *ngIf="retention.policytype=='Fixed'" class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Policy Date</div>
                                    <div class="col-8 properties-value">{{retention.policydate | date}}</div>
                                </div>
                            </div>
                            <div *ngIf="retention.policytype=='Duration'" class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Policy Duration</div>
                                    <div class="col-8 properties-value">{{retention.policyduration}}</div>
                                </div>
                            </div>
                            <div class="container m-1">
                                <div class="row" matLine>
                                    <div class="col-4" style="font-weight: 500">Disposition</div>
                                    <div class="col-8 properties-value">{{retention.disposition_date | date}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <form>
                    <div class="input-group-sm mb-3 mt-2 input-group col-12">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Hold</span>
                        </div>
                        <mat-select name="hold_names" class="form-control" [(ngModel)]="holdIDs"
                            (ngModelChange)="holdIDs">
                            <mat-option>
                                <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                    [noEntriesFoundLabel]="'Not found'" name="search"
                                    [ngModelOptions]="{standalone: true}">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let hold of allHolds|stringFilter:searchCtrl:'name'" [value]="hold.id">
                                {{hold.name}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <button class="ml-3" mat-stroked-button (click)="applyHold()">
                        Apply Hold
                    </button>
                </form> -->
            </mat-list-item>
        </div>
    </mat-expansion-panel>

</mat-accordion>